import React from "react";
import i18next from "i18next";
import Section from "components/Section/Section";
import { Trans } from "react-i18next";
import { TitleHighlight } from "components/Section/Section.styled";
import useDevice from "hooks/useDevice";
import introOurWork from "../../static/intro-our-work.png";
import {
  ImageContainer,
  ImageElementSimple,
  OurWorkContainer,
  OurWorkIntro,
  YourIdeasContainer,
  YourIdeasText,
} from "./OurWorkPage.styled";
import { HelpContainer, HelpText } from "./OurWorkPage.styled";
import { Highlight } from "../../components/Hightlight/Hightlight.style";
import Stats from "components/Stats/Stats";
import ActionButton from "components/Button/ActionButton/ActionButton";
import { ReactComponent as ButtonIcon } from "assets/images/svg/arrow-up-right-black.svg";
import { PAGES } from "constants/pages";
import CaseStudy from "components/CaseStudy/CaseStudy";

const OurWorkPage = () => {
  const { isMobile, isTablet, isDesktop } = useDevice();
  document.title = i18next.t(PAGES.CASE_STUDIES.title);

  return (
    <>
      <Section
        isStyled={true}
        bgColor="white"
        titleAlignLeft
        cardTitle={
          <Trans
            components={[<TitleHighlight fontWeight="extraBold" key={0} />]}
            i18nKey="ourWorkPage.title"
          />
        }
        margin={isMobile ? "76px 0px 10px" : "170px 10px 48px"}
        paddingBottom={isMobile ? "10px" : "32px"}
        lineHeight={isDesktop ? "82px" : "125%"}
      >
        <OurWorkContainer>
          <OurWorkIntro>
            <Trans
              i18nKey="ourWorkPage.introText"
              components={[
                <Highlight color="secondaryOpaque" key={0} isText={true} />,
              ]}
            />
          </OurWorkIntro>
          <ImageContainer>
            <ImageElementSimple src={introOurWork} />
          </ImageContainer>
        </OurWorkContainer>
      </Section>
      <Section
        bgColor="dark"
        margin={isMobile || isTablet ? "64px 0px 32px" : "160px 0px 80px"}
        paddingBottom={isMobile || isTablet ? "3px" : "28px"}
      >
        <Stats />
      </Section>
      <Section
        isStyled={true}
        bgColor="white"
        cardTitle={
          <Trans
            i18nKey="ourWorkPage.challengeToSolution.title"
            components={[
              <TitleHighlight
                fontWeight="extraBold"
                isStyled={false}
                key={0}
              />,
              <TitleHighlight fontWeight="extraBold" isStyled={true} key={1} />,
            ]}
          />
        }
        margin={isMobile || isTablet ? "40px 0px 20px" : "160px 0px 80px"}
        paddingBottom={isMobile || isTablet ? "10px" : "32px"}
        lineHeight={"125%"}
      >
        <CaseStudy />
      </Section>
      <Section
        isStyled={true}
        bgColor="dark"
        titleAlignLeft={false}
        cardTitle={
          <Trans
            components={[
              <TitleHighlight fontWeight="extraBold" isStyled={true} key={0} />,
            ]}
            i18nKey="ourWorkPage.yourIdeas.title"
          />
        }
        margin={isMobile || isTablet ? "40px 0px 20px" : "160px 0px 80px"}
        paddingBottom={isMobile || isTablet ? "10px" : "32px"}
        lineHeight={isDesktop ? "100%" : "125%"}
      >
        <YourIdeasContainer>
          <YourIdeasText>
            <Trans
              i18nKey="ourWorkPage.yourIdeas.text"
              components={[
                <Highlight color="thertiary" key={0} isText={true} />,
              ]}
            />
          </YourIdeasText>
          <ActionButton
            size={"md"}
            isLink={true}
            marginTop={"0px"}
            maxWidth={"379px"}
            width={!isMobile ? "379px" : "144px"}
            height={!isMobile ? "120px" : "51px"}
            padding={!isMobile ? "38px 44px" : "19px 22px"}
            font={!isMobile ? "24px" : "11px"}
            iconSize={"8.7px"}
          >
            <Trans i18nKey="ourWorkPage.yourIdeas.hireUs" />
            <ButtonIcon></ButtonIcon>
          </ActionButton>
        </YourIdeasContainer>
      </Section>
      <Section
        isStyled={true}
        bgColor="white"
        cardTitle={
          <Trans
            i18nKey="ourWorkPage.help.title"
            components={[
              <TitleHighlight fontWeight="extraBold" isStyled={true} key={0} />,
            ]}
          />
        }
        margin={isMobile || isTablet ? "40px 0px 20px" : "160px 0px 80px"}
        paddingBottom={isMobile || isTablet ? "3px" : "28px"}
        lineHeight={isDesktop ? "100%" : "125%"}
      >
        <HelpContainer>
          <HelpText>
            <Trans
              i18nKey="ourWorkPage.help.text"
              components={[
                <Highlight color="thertiary" key={0} isText={true} />,
              ]}
            />
          </HelpText>
          <ActionButton
            size={"md"}
            marginTop={"0px"}
            maxWidth={"379px"}
            to={PAGES.HOW_WE_CAN_HELP.route}
            width={!isMobile ? "379px" : "144px"}
            height={!isMobile ? "120px" : "51px"}
            padding={!isMobile ? "38px 44px" : "19px 10px"}
            font={!isMobile ? "24px" : "11px"}
            iconSize={"8.7px"}
          >
            <Trans i18nKey="ourWorkPage.help.checkItOut" />
            <ButtonIcon></ButtonIcon>
          </ActionButton>
        </HelpContainer>
      </Section>
    </>
  );
};

export default OurWorkPage;
